import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const DEMO_QUERY_PARAM = "marketingDemo";

function isTruthy(value) {
  const key = String(value || "")
    .trim()
    .toLowerCase();
  return ["1", "true", "yes", "ja", "on"].includes(key);
}

export function isMarketingDemoFeatureEnabled() {
  return isTruthy(process.env.REACT_APP_MARKETING_DEMO || "");
}

export function useMarketingDemoMode() {
  const location = useLocation();

  return useMemo(() => {
    if (isMarketingDemoFeatureEnabled()) return true;
    const params = new URLSearchParams(location.search || "");
    return isTruthy(params.get(DEMO_QUERY_PARAM));
  }, [location.search]);
}

export function getDemoWorkorderNumber(index = 0) {
  const safeIndex = Number.isFinite(Number(index)) ? Number(index) : 0;
  return `WB-DEMO-2026-${String(safeIndex + 1).padStart(3, "0")}`;
}

export function getDemoWorkorderTitle(index = 0) {
  const titles = [
    "Onderhoud brandmeldinstallatie",
    "Storing rookmelder liftschacht",
  ];
  return titles[Math.abs(Number(index || 0)) % titles.length];
}

export function getDemoProjectName() {
  return "BMI onderhoud 2026";
}

export function getDemoClientName() {
  return "Demo Installatiebedrijf";
}

export function getDemoLocationName() {
  return "Kantoor Hoofdgebouw";
}
